import styled from '@emotion/styled'

export const StyleCardWrapper = styled.div`
  width: 50%;
  padding: 20px;
  border-radius: 8px;
  margin: 0px auto;
  border: 1px solid ${(props: any) => props.theme.colors.secondary};
  background: white;
  @media (max-width: 1024px) {
    width: 70%;
  }
  @media (max-width: 767px) {
    width: 100%;
  }
`
export const styleColumn = `
    min-height: 85vh;
    padding:30px 0px;
  
    

`

export const StyleTitle = styled.h3`
  font-size: 16px;
  font-weight: 600;
`
